import { AbstractFormatAlert } from "./AbstractFormatAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";

export abstract class AbstractFormatObjectsAlert extends AbstractFormatAlert {
  constructor(target: string, isError: boolean) {
    super(isError);
    this._target = target;
  }

  protected readonly _target: string;
  
  get target(): string {
    return this._target;
  }

  get kind(): string {
    return "オブジェクト警告";
  }

  get detectedObject(): IFormatObjectEditable {
    return null;
  }
}
